import { toggleMetric, toggleSwitch } from "actions/tool-panel/draft/actions";
import { connect } from "react-redux";
import { MetricsSection, PassedProps } from "./metrics-section";

export const MetricsSectionContainer = connect<{}, {}, PassedProps>(null, { toggleMetric, toggleSwitch })(
    MetricsSection
);
